export const Style = {
    AboutPaper1: {
        p: 4,
        textAlign: 'center',
        height: '100%',
        borderRadius: 3,
        transition: 'transform 0.3s ease-in-out',
        '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: 6,
        },
        cursor: "pointer"

    },
    AboutPaper2: {
        p: 4,
        textAlign: 'center',
        height: '100%',
        borderRadius: 3,
        transition: 'transform 0.3s ease-in-out',
        '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: 6,
        },
        cursor: "pointer"

    },
    AboutPaper3: {
        p: 4,
        textAlign: 'center',
        height: '100%',
        borderRadius: 3,
        transition: 'transform 0.3s ease-in-out',
        '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: 6,
        },
        cursor: "pointer"

    },
    commonHeading: {
        fontWeight: 'bold',
        color: 'primary.main',
        mb: 2,

    },
    commonTextForwhatwedo: {
        color: 'text.secondary',
        mb: 6,
        maxWidth: '700px',
        mx: 'auto',
        lineHeight: 1.6,
    },
    BackGroundColorWhatWeDo1: {
        height: '100%',
        borderRadius: 3,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
    },
    BookingMethodBox1: {
        p: 3,
        borderRadius: 3,
        backgroundColor: '#f5f5f5',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: 'primary.light',
            color: 'white',
            transform: 'translateY(-4px)',
        },
        cursor: "pointer"
    },
    BokkingMethosBox2: {
        p: 3,
        borderRadius: 3,
        backgroundColor: '#f5f5f5',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: 'success.light',
            color: 'white',
            transform: 'translateY(-4px)',
        },
        cursor: "pointer"
    },
    BookingMethodBox3: {
        p: 3,
        borderRadius: 3,
        backgroundColor: '#f5f5f5',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: 'secondary.light',
            color: 'white',
            transform: 'translateY(-4px)',
        },
        cursor: "pointer"

    },
    HelpPaperCommon: {
        p: 3,
        textAlign: 'center',
        borderRadius: 3,
        transition: 'transform 0.3s ease',
        '&:hover': { transform: 'translateY(-4px)' },
        cursor: "pointer"
    },
    commonChipSlotBooking: {
        backgroundColor: 'rgba(255,255,255,0.2)',
        color: 'white',
        fontWeight: 'bold',
        cursor: "pointer"
    },
    commonBoxWalk: {
        height: '100%',
        borderRadius: 3,
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        color: 'white',
    }
}